import { useUniqueId } from "Hooks";
import React from "react";

interface LeftBottomLineProps {

}

const LeftBottomLine: React.FC<LeftBottomLineProps> = () => {
   const id = useUniqueId();
   return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 366 168" width="366" height="168" fill="none">
      <path stroke={`url(#${id})`} strokeLinecap="round" strokeWidth="8" d="M602.447 5.862C544.706 68.729 384.028 149.149 219.439 127.88 120.536 115.101 75.97 50.237 96.425 18.266c10.465-16.358 39.393-7.436 37.996 15.913-.418 6.994-3.721 28.558-32.758 34.309C12.867 86.052-19.561 31.775-91.521 30.628" />
      <defs>
         <linearGradient id={id} x1="-122.969" x2="606.896" y1="100.032" y2="-37.087" gradientUnits="userSpaceOnUse">
            <stop offset=".07" stopColor="#00619D" />
            <stop offset=".63" stopColor="#A4D9D0" />
            <stop offset=".85" stopColor="#BBDB94" />
            <stop offset=".99" stopColor="#BBDB94" />
         </linearGradient>
      </defs>
   </svg>
}

export default LeftBottomLine;